import type { IUserService, IGameService, IStreamerService } from './api.interface';
import { MockUserService } from './mock/mock-user.service';
import { MockGameService } from './mock/mock-game.service';
import { MockStreamerService } from './mock/mock-streamer.service';

export type { IUserService, IGameService, IStreamerService } from './api.interface';
export type {
  UserProfile,
  BalanceInfo,
  AudioPreferences,
  AvatarType,
  CrashRecord,
  BetOutcome,
  SlotPreferences,
  StreamerInfo,
  StreamerRegistryEntry,
  StreamerSampleBet,
  StreamerMessage,
  StreamerRoomStats,
  StreamerTopWinner,
  HypeThreshold,
  StreamerPromo,
  StreamerEvent,
} from './types';
export { StorageService, StorageKeys } from './storage.service';

const userService: IUserService = new MockUserService();
const gameService: IGameService = new MockGameService();
const streamerService: IStreamerService = new MockStreamerService();

export const UserService: IUserService = userService;
export const GameService: IGameService = gameService;
export const StreamerService: IStreamerService = streamerService;
